import ReactDOM from "react-dom/client";

import AppProvider from "hooks/index.tsx";

import ReduxProvider from "store/provider";

import App from "./App.tsx";
import "./index.css";
import "multitenancy/i18n";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AppProvider>
    <ReduxProvider>
      <App />
    </ReduxProvider>
  </AppProvider>,
);
